import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {Dibujo, DibujoType} from '../../../chacra-core';

import {ConfirmDialogComponent, ConfirmDialogData, ConfirmDialogResultType, FormActionType,} from '../../../shared';
import {select, Store} from "@ngrx/store";
import {AppState} from "../../../core/store/core.state";
import {selectAllDibujos} from 'src/app/features/store/entities/shared/dibujos/dibujos.selectors';
import {selectUIMapChacra, selectUIParamFromURL} from 'src/app/features/store/ui/ui.selectors';
import {BaseComponent} from 'src/app/shared/components/base/base.component';
import {UrlParam} from '../index';

@Component({
  selector: 'app-base-crud',
  template: '',
})
export class BaseCrudComponent<T> extends BaseComponent implements OnInit, OnDestroy {

  items: T[] = [];
  allItems: T[] = [];
  attrId: string;
  ctor: new () => T;
  ctorDialog: any;
  urlParam: UrlParam;

  DIALOG_WIDTH = '500px';
  DIALOG_MAX_HEIGHT = '500px';

  itemId: string = null;
  canUserCrudProp = false;

  btnAdd = false;
  btnUpdate = false;
  btnDelete = false;

  polygons: Dibujo[] = [];
  dibujos: Dibujo[] = [];

  @Output() itemSelectedEvent = new EventEmitter<T>();
  @Output() canAddEvent = new EventEmitter<boolean>();

  constructor(
    protected route: ActivatedRoute,
    protected store: Store<AppState>,
    protected dialog: MatDialog,
    protected router: Router
  ) {
    super();
  }

  @Input()
  public get openPopup(): boolean {
    return false;
  }

  public set openPopup(value: boolean) {
    if (value) {
      this.add();
    }
  }

  @Input()
  public get canUserCrud(): boolean {
    return this.canUserCrudProp;
  }

  public set canUserCrud(value: boolean) {
    this.canUserCrudProp = value;
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.store.select(selectAllDibujos).subscribe(dibujos => {
        this.dibujos = dibujos;
        this.polygons = this.dibujos.filter(
          d => d.dibujoTipo === DibujoType.POLYGON
        );
        // if (this.polygons.length > 0) {
        //   this.btnAdd = true;
        // } else {
          this.btnAdd = false;
        // }
        this.dibujosChange();
      })
    );

    this.subscriptions.push(
      this.store.select(selectUIMapChacra).subscribe(chacra => {
        if (chacra) {
          this.itemId = null;
          this.itemChange();
        }
      })
    );

    if (this.urlParam) {
      this.subscriptions.push(
        this.store.pipe(select(selectUIParamFromURL(this.urlParam))).subscribe(
          (itemId: string) => this.itemId = itemId));
    }

    this.itemChange();
  }

  dibujosChange() {
    this.canAddEvent.emit(this.btnAdd);
  }

  getItem() {
    const item = this.allItems.find(a => a[this.attrId] === this.itemId);
    return item;
  }

  add() {
    this.openDialog(FormActionType.Add, new this.ctor());
  }

  update() {
    const item = this.getItem();
    this.openDialog(FormActionType.Update, {...item});
  }

  openDialog(action: FormActionType, item: T) {
    const inData = this.getDialogData(action, item);
    this.dialog.open(this.ctorDialog, {
      width: this.DIALOG_WIDTH,
      data: inData
    });
  }

  getDialogData(action: FormActionType, item: T): any {
    return null;
  }


  openConfirmDialog(title: string, question: string, action: any) {
    const inData: ConfirmDialogData = {
      title,
      question,
      result: ConfirmDialogResultType.Cancel
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: this.DIALOG_WIDTH,
      maxHeight: this.DIALOG_MAX_HEIGHT,
      data: inData
    });
    dialogRef.afterClosed().subscribe(outData => {
      if (outData && outData.result === ConfirmDialogResultType.Ok) {
        if (action) {
          this.store.dispatch(action);
        }
      }
    });
  }

  dataChange() {
    // if (this.polygons.length > 0) {
    //   this.btnAdd = true;
    // } else {
      this.btnAdd = false;
    // }
    this.dibujosChange();
  }

  itemChange() {
    let item = null;
    this.btnUpdate = false;
    this.btnDelete = false;
    if (this.itemId) {
      this.btnUpdate = true;
      this.btnDelete = true;
      item = this.getItem();
    }

    if (this.urlParam) {
      this.router.navigate(
        [],
        {
          relativeTo: this.route,
          queryParams: {[this.urlParam]: this.itemId},
          queryParamsHandling: 'merge'
        });
    }
    this.itemSelectedEvent.emit(item);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
